import React, { useState, useEffect } from 'react'
import Api from '../../../pages/api/api'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import { Modal, Grid } from '@material-ui/core'
import strings from '../../strings/strings.json'
import styles from './emulator_modal.module.css'
import { Progress, Switch } from 'antd'
import Backdrop from '@material-ui/core/Backdrop'
import NativeSelect from '@material-ui/core/NativeSelect';
import emulator_procress from '../../../public/assets/animation/emulator_procress.json'
import Lottie from 'react-lottie';


let id = null
let getUrlId = null
export default function EmulatorModal(props) {

    const useStyles = makeStyles((theme) => ({
        paper: {
            position: "absolute",
            width: 900,
            backgroundColor: "#ffffff",
            border: 0,
            boxShadow: "0 10px 80px 2px rgba(77, 72, 103, 0.15)",
            padding: theme.spacing(4, 4, 3),
            paddingBottom: "50px",
            left: "50%",
            top: "50%",
            display: "block",
            overflowY: "auto",
            outline: 0,
            transform: "translate(-50%, -50%)",
            borderRadius: "15px",

            [theme.breakpoints.down('xs')]: {
                width: 270,
                padding: 10,
            },
            [theme.breakpoints.up('xs')]: {
                width: 350,
            },
            [theme.breakpoints.down('sm')]: {
                /*     overflowY: "scroll", */
            },
            [theme.breakpoints.up('sm')]: {
                width: 600,
            },
            [theme.breakpoints.up('md')]: {
                width: 800,
            }
        },
        underline: {
            backgroundColor: 'rgba(7, 70, 93, 0.1)',
            color: "#07465d",
            borderRadius: "10px",
            fontSize: ".8rem",
            width: "200px",
            textAlign: "center !important",
            "& .MuiNativeSelect-select:focus": {
                backgroundColor: "transparent",
            },
            "& .MuiNativeSelect-root": {
                textAlign: "center",
                paddingLeft: 0
            }
        }
    }))

    const classes = useStyles()
    const [openErrorModal, setOpenErrorModal] = useState(false)
    const [percent, setPercent] = useState(0)
    const [isSwitch, setIsSwitch] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isSuccess, setIsSuccess] = useState(false)
    const [isFade, setIsFade] = useState(false)
    const [emuUrl, setEmuUrl] = useState('')
    const [deviceType, setDeviceType] = useState("gals9")
    const [isCaptureNetwork, setIsCaptureNetwork] = useState(false)

    useEffect(() => {

        return () => {
            clearInterval(id)
            clearInterval(getUrlId)
        }
    }, [props.open])

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: emulator_procress,
        rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
    }

    const renderCheckboxContainer = (title, isChecked, isDivider) => {
        return (
            <div className={`${isDivider ? styles.is_divider : null} ${styles.render_checkbox_container}`}>
                <span className={`${styles.render_title} primary_color`}><div className={styles.input_container}>{title}{title === strings.emulator_takePicRun ? <div><input className={styles.input} disabled /> <span>{strings.general_second}</span></div> : ""}</div></span>
                <div>
                    <span className={`${styles.render_subTitle} secondry_color ml-2`}>{!isChecked ? strings.general_deactive : strings.general_active}</span>
                    <Switch checked={title === strings.emulator_run ? isCaptureNetwork : false} onChange={(checked) => setIsCaptureNetwork(checked)} disabled={title === strings.emulator_run ? false : true} />
                </div>
            </div>
        )
    }

    const runAppHandler = () => {
        doStart()
    }

    const doStart = () => {
        setIsLoading(true)
        Api.emulatorStart({
            "md5": props.data.md5,
            "capture_network": isCaptureNetwork
        })
            .then(startResult => {
                getUrlId = setInterval(() => {
                    setIsSwitch(true)
                    setIsFade(true)
                    Api.emulatorGetUrl({
                        "md5": props.data.md5,
                    })
                        .then(urlResult => {
                            clearInterval(getUrlId)
                            if (urlResult.url) {
                                setEmuUrl(urlResult.url)
                                setIsSuccess(true)
                                setIsLoading(false)
                                setIsSwitch(false)
                                setIsFade(false)
                            } else {
                                setOpenErrorModal(true)
                            }
                        })
                        .catch(urlErr => {
                        })
                }, 5000);
            })
            .catch(err => {
                props.close()
                if (err.status === 403 && err.error === 701)
                    props.setSnack(true, "error", strings.emualtor_closeSessionError)
                else
                    props.setSnack(true, "error",
                        <div style={{ direction: "ltr" }}>
                            <div>{err.message}</div>
                            {
                                err.info !== undefined &&
                                <div>{err.info}</div>
                            }
                        </div>
                    )
            })

        let percent = 0
        id = setInterval(() => {
            percent += 1
            if (percent >= 100 || emuUrl) {
                clearInterval(id)

            }
            setPercent(percent)
        }, 1000);

    }

    const openURlHandler = () => {
        window.open(emuUrl)
        props.close()
    }

    return (
        <Modal
            disableScrollLock={true}
            open={props.open}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <div /* style={(!isSwitch || !isSuccess) ? { height: "95%" } : null}  */ className={classes.paper}>
                <img className={styles.close} src="/assets/icons/close.svg" alt="Icon" onClick={() => props.close()} />
                {
                    openErrorModal ?
                        <div className={styles.emulator_error_container}>
                            <img className={styles.error_img} src="/assets/icons/emulator_error.svg" alt="Icon" />
                            <div className="flex column flex_center">
                                <span className={styles.emulator_error_title}>{strings.emulator_errorTitle}</span>
                                <span className={styles.emulator_error_subTitle}>{strings.emulator_errorSub}</span>
                            </div>
                            <div className="flex flex_center">
                                <button className={`${styles.review_btn} ${styles.error_btn}`} onClick={() => props.reviewClicked()}>{strings.emulator_review}</button>
                                <button className={`${styles.cancel_btn} ${styles.error_btn}`} onClick={() => props.close()}>{strings.general_cancel}</button>
                            </div>
                        </div>

                        : isSwitch
                            ? (
                                <React.Fragment>
                                    <div className={`${styles.anim_container} ${isFade ? styles.fade_android_anim : null}`} >
                                        <Lottie
                                            options={defaultOptions}
                                            height={150}
                                            width={150}
                                            isStopped={false}
                                            isPaused={false} />
                                    </div>
                                    <div className={styles.title_container}>
                                        <span className={`${styles.title} primary_color`}>{strings.general_waiting}</span>
                                        <span className={`${styles.subTitle} secondry_color`}>{strings.fileDetails_emuModalSub}</span>
                                    </div>
                                    <div className={`${styles.progress_title} ${styles.title_container}`}>
                                        <span className={`${styles.title} primary_color`}>{strings.fileDetails_emuModalProg} ({percent}%)</span>
                                        <span className={`${styles.subTitle} secondry_color englishIranSans`}>{props.data.program_name}</span>
                                    </div>
                                    <div className={styles.progress_container} dir="ltr">
                                        <Progress strokeColor="#41b9a2" percent={percent} showInfo={false} strokeWidth={20} />
                                    </div>
                                </React.Fragment>
                            )
                            : isSuccess
                                ? (
                                    <React.Fragment>
                                        <div className={styles.anim_container}><img className={styles.checkbox_img} src="/assets/icons/success_checkbox_amulator.svg" alt="Icon" /></div>
                                        <div className={styles.title_container}>
                                            <span className={`${styles.title} primary_color`}>{strings.fileDetails_emuModalSuccess}</span>
                                            <span className={`${styles.subTitle} secondry_color`}>{strings.fileDetails_emuActivePnPromise}</span>
                                        </div>
                                        <div className='mt-5 flex justify-center items-center'>
                                            <button className={styles.run_btn} onClick={() => openURlHandler()}>
                                                <span className='text-white font-bold'>باز کردن لینک شبیه ساز</span>
                                            </button>
                                        </div>
                                    </React.Fragment>
                                )
                                :
                                (
                                    <React.Fragment>
                                        <div className={`center`}>
                                            <div className={styles.settings_checkbox_container}>
                                                <Grid container>
                                                    <Grid item xs={12} sm={6} md={6} lg={6}>
                                                        <div className={styles.settings_right_side}>
                                                            {renderCheckboxContainer(strings.emulator_run, isCaptureNetwork, true)}
                                                            {renderCheckboxContainer(strings.emulator_recordRun, false, true)}
                                                            {renderCheckboxContainer(strings.emulator_takePicRun, false, true)}
                                                            {renderCheckboxContainer(strings.emulator_activeAntiRoot, false, false)}
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={6} lg={6}>
                                                        <div>
                                                            {renderCheckboxContainer(strings.emulator_logcat, false, true)}
                                                            {renderCheckboxContainer(strings.emulator_fileSystemEvent, false, true)}
                                                            {renderCheckboxContainer(strings.emulator_activeAntiEmulator, false, true)}
                                                            {renderCheckboxContainer(strings.emulator_fridaScript, false, false)}
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </div>
                                            <div className={styles.settings_checkbox_container}>
                                                <div>
                                                    <Grid container>
                                                        <Grid item xs={12} sm={6} md={6} lg={6}>
                                                            <div className={`${styles.render_checkbox_container} ${styles.settings_right_side}`}>
                                                                <span className={`${styles.render_title} primary_color`}>{strings.emulator_deviceType}</span>
                                                                <div>
                                                                    <NativeSelect disabled className={classes.underline} disableUnderline>
                                                                        <option value="gals9">Samsung Galaxy S9</option>
                                                                        <option value="gals8">Samsung Galaxy S8</option>
                                                                        <option value="gals7edge">Samsung Galaxy S7 Edge</option>
                                                                        <option value="gals7">Samsung Galaxy S7</option>
                                                                        <option value="gals6">Samsung Galaxy S6</option>
                                                                        <option value="nex4">Nexus 4</option>
                                                                        <option value="nex5">Nexus 5</option>
                                                                        <option value="nexone">Nexus One</option>
                                                                        <option value="nexs">Nexus S</option>
                                                                        <option value="nex7">Nexus 7</option>
                                                                    </NativeSelect>
                                                                </div>

                                                            </div>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={6} lg={6}>
                                                            <div className={`${styles.render_checkbox_container}`}>
                                                                <span className={`${styles.render_title} primary_color`}>{strings.emulator_osType}</span>
                                                                <div>
                                                                    <NativeSelect disabled className={classes.underline} disableUnderline>
                                                                        <option value="and5">Android 5.0</option>
                                                                        <option value="and6">Android 6.0</option>
                                                                        <option value="and7">Android 7.0</option>
                                                                        <option value="and8">Android 8.0</option>
                                                                        <option value="and9">Android 9.0</option>
                                                                        <option value="and10">Android 10.0</option>
                                                                        <option value="and11">Android 11.0</option>
                                                                    </NativeSelect>
                                                                </div>
                                                            </div>
                                                        </Grid>
                                                    </Grid>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className={styles.run_btn_container}>
                                                <button className={styles.run_btn} onClick={() => !isLoading && runAppHandler()}>
                                                    {!isLoading && <img src="/assets/icons/run_app.svg" alt="Icon" />}
                                                    <span>{!isLoading ? strings.general_runApp : strings.general_wait}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                )
                }
            </div>
        </Modal >
    )
}
